export const resources_welcome = {
  en: {
    translation: {
      welcome: {
        welcome: 'Welcome to OpenSankey web application',
        breadcrumbs: {
          intro: 'Overview',
          //interface: 'Interface',
          rc: 'Essentials',
          //licence: 'Licences',
        },
        read_me: 'Read me',
        intro: 'Feature Guide',
        interface: 'Interface\'s buttons explained',
        rc: 'Mouse interactions, toolbar and keyboard shortcuts',
        licence: 'Licences',
        1: 'Mouse mode selection button, there are 2 modes: a mode to select nodes and links to be able to move them, then a mode to create links and nodes with mouse click',
        2: 'Buttons to filter the visibility or colors of nodes and links according to the groups to which they are associated',
        3: 'Buttons to filter the nodes according to their aggregation level',
        4: 'Buttons to filter the visibility of the links according to their values, this button also allows to modify the scale of the diagram (the thickness of the links)',
        5: 'Buttons to adjust the size of the drawing area so that all elements are visible',
        6: 'Buttons to display the diagram without taking into account the value of the links',
        7: 'Buttons to display additional help',
        8: 'Navigation menu to open,save, edit sankeys',
        9: 'Buttons to connect with an opensankey account and enable additional modules',
        10: 'Buttons to open the configuration menu to edit the elements of the sankey diagram',
        excel: 'Button download the data used for the sankey in Excel format'
      },
      useTemplate: 'Use this template',
      DisplayWelcome: 'Welcome',
      dontSeeAgain: 'Don\'t show again',
      scale: 'Scale',
      useTutoJSON: 'Open',
      useTutoExcel: 'Open Excel',
      menuTuto: 'Open tutorials menu',
      desire_to_know_more: 'Learn more',
      contribute_to_os: 'En savoir +',
      legal: 'Legal informations',
      tdr: 'All right reserved',
      fullscreen: 'Activate fullscreen',
      exitFullscreen: 'Exit fullscreen',
      Avancé: 'Advanced',
      separator_interval: ',',
      sep_decimal: '.',
      diaporama: 'Presentation',
      start: 'Start',
      tooltip: {
        dontSeeAgain: 'By checking this box, the welcome screen will no longer appear on the next page load. To display this welcome screen again, go to Help->Home.',
        diaporama: 'Presentation of the various features of the tool, from the most basic to the most advanced as well as mouse/keyboard combination for edition.',
        start: 'Start drawing your flows. To do this, click in the drawing area, drag without releasing, then release.'
      }
    }
  },
  fr: {
    translation: {
      welcome: {
        welcome: 'Bienvenue sur l\'application web OpenSankey',
        breadcrumbs: {
          intro: 'Fonctionnalités',
          //interface: 'Boutons et Menus',
          rc: 'L\'essentiel',
          //licence: 'Licences',
        },
        read_me: 'Lisez moi',
        intro: 'Guide des fonctionnalités',
        interface: 'Présentation des actions associées aux boutons et menus',
        rc: 'Interactions souris, barre d\'outils et raccourcis clavier',
        licence: 'Optez pour la licence adaptée à votre usage',
        1: 'Bouton de sélection du mode de la souris, il existe 2 modes : un mode permettant de sélectionner les noeuds et flux pour pouvoir les déplacer, puis un mode permettant de créer des liens et noeuds aux cliques de la souris',
        2: 'Boutons permettant de filtrer la visibilité ou couleurs des noeuds et flux en fonction des groupes auxquels ils sont associés',
        3: 'Bouton permettant de filtrer les noeuds en fonction de leur niveau d\'agrégation',
        4: 'Bouton permettant de filtrer la visibilité des flux en fonction de leurs valeurs, ce bouton permet aussi de modifier l\'échelle du diagramme (l\'épaisseur des flux)',
        5: 'Bouton permettant de réajuster la taille de la zone de dessin pour que tous les éléments soient visibles',
        6: 'Bouton permettant d\'afficher le diagramme sans prendre en compte la valeur des flux',
        7: 'Bouton permettant d\'afficher de l\'aide supplémentaire',
        8: 'Menu de navigation permettant d\'ouvrir, enregistrer, éditer des sankeys',
        9: 'Bouton permettant de se connecter avec un compte opensankey et activer des modules supplémentaires',
        10: 'Bouton permettant d\'ouvrir le menu de configuration qui permet d\'éditer les éléments du diagramme de sankey',
        excel: 'Bouton permettant de télécharger les données au format Excel'
      },
      useTemplate: 'Utiliser ce modèle',
      DisplayWelcome: 'Accueil',
      dontSeeAgain: 'Ne plus montrer',
      scale: 'Échelle',
      useTutoJSON: 'Ouvrir',
      useTutoExcel: 'Ouvrir Excel',
      menuTuto: 'Ouvrir menu tutoriel',
      desire_to_know_more: 'En savoir +',
      contribute_to_os: 'En savoir +',
      legal: 'Mentions légales',
      tdr: 'Tous droits réservées',
      fullscreen: 'Activer le mode plein écran',
      exitFullscreen: 'Quitter le mode plein écran',
      Avancé: 'Avancé',
      separator_interval: ';',
      sep_decimal: ',',
      diaporama: 'Présentation',
      start: 'Démarrer',
      tooltip: {
        dontSeeAgain: 'En cochant cette case il n\'y aura plus d\'écran d\'accueil au prochaine chargement de la page. Pour réafficher cet accueil aller dans Aide->Accueil.',
        diaporama: 'Présentation des différentes fonctionnalités de l\'outil des plus basiques aux plus avancées, ainsi que les combinaisons souris/claviers d\'édition.',
        start: 'Commencez à tracer vos flux. Pour cela cliquez dans la zone de dessin, faites glisser sans relâcher, puis relâchez.'
      }
    }
  }
}